// extracted by mini-css-extract-plugin
module.exports = {"containerInner":"LandingSolana_containerInner__2WD7U","description":"LandingSolana_description__DTCM6","title":"LandingSolana_title__1eJ14"};